import React from 'react';
import config from '../config';

const ResultsHeader = ({
  totalCount,
  grantedCount,
  pendingCount,
  results,
  query,
  user,
  patentStatus,
  searchType,
  setShowLoginPrompt,
  setLoginPromptMessage,
  statusFilter,
  setStatusFilter
}) => {
  if (results.length === 0) {
    return null;
  }

  return (
    <>
      {/* Result Count */}
      <div style={{
        marginBottom: '16px',
        padding: '12px 16px',
        backgroundColor: '#e8f4f8',
        borderRadius: '8px',
        borderLeft: '4px solid #53dafc'
      }}>
        <span style={{ fontSize: '16px', fontWeight: '600', color: '#1d2934' }}>
          Found {totalCount.toLocaleString()} patents matching your criteria. Showing {results.length === totalCount ? `all ${results.length}` : `top ${results.length}`}.
{/* Status Filter Dropdown */}
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{
              marginLeft: '12px',
              padding: '4px 8px',
              borderRadius: '6px',
              border: '1px solid #cbd5e1',
              fontSize: '14px',
              cursor: 'pointer',
              background: 'white'
            }}
          >
            <option value="all">Show: All ({totalCount})</option>
            <option value="granted">Granted Only ({grantedCount})</option>
            <option value="pending">Pending Only ({pendingCount})</option>
          </select>
          {totalCount > 100 && (
            <span style={{ display: 'block', fontSize: '14px', fontWeight: '400', color: '#64748b', marginTop: '8px' }}>
              Tip: Try adding more specific keywords to narrow your results (e.g., "{query} {
                query.toLowerCase().includes('battery') ? 'cathode material' :
                query.toLowerCase().includes('machine learning') ? 'medical diagnosis' :
                query.toLowerCase().includes('solar') ? 'perovskite cell' :
                query.toLowerCase().includes('vehicle') ? 'lidar sensor' :
                'specific application'
              }")
            </span>
          )}
        </span>
      </div>

      {/* Export Button */}
      {results.length > 0 && (
        <button
          onClick={() => {
            const token = localStorage.getItem('token');
            
            // Check if user is logged in
            if (!user) {
              setLoginPromptMessage('Register free to export patent search results to CSV. Export up to 20 patents with a free account, or upgrade for more.');
              setShowLoginPrompt(true);
              return;
            }
            
            const params = new URLSearchParams({
              query: query,
              status: patentStatus,
              assignee_only: searchType === 'assignee',
              inventor_only: searchType === 'inventor',
              patent_only: searchType === 'patent'
            });
            if (token) {
              params.append('token', token);
            }
            window.open(`${config.API_URL}/api/export-csv-prepare?${params.toString()}`, '_blank');
          }}
          style={{
            background: '#10b981',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          Export to CSV ({user?.tier === 'pro' ? '1000' : user?.tier === 'premium' ? '100' : '20'} patents max)
        </button>
      )}
    </>
  );
};

export default ResultsHeader;
